import api from "../services/api";

export const fetchDataMenu = async ({ userName, token }) => {
  try {
    const response = await api.get("/get-data-menu", {
      params: { userName: userName },
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const captureLog = async ({ appName, userName, token }) => {
  if (!appName || !userName) return;
  try {
    const response = await api.post(
      `/logs`,
      {
        appName,
        userName: userName,
      },
      {
        headers: {
          Authorization: token,
        },
      },
    );
    console.log("Log capturado:", response.data);
  } catch (error) {
    console.error("Error al capturar log:", error);
  }
};
